import withAPIAction from '../../../utils/withAPIAction'
import {
  getCheckListAction,
  getCheckListByIdAction,
  deleteCheckListAction,
  createCheckListAction,
  updateCheckListAction,
  getProjectAction,
} from './actions'

import { CreateCheckListReq, UpdateCheckListReq } from './types'

// get list
export const getCheckList = (
  Page: number,
  RowPerPage: number,
  TextFilter: string = '',
  ChecklistTypeID: number = 0
) => {
  return withAPIAction(state => ({
    method: 'POST',
    path: 'GetConstructPlanCheckList',
    data: {
      UserEmail: state.sensitive.userEmail,
      Page,
      RowPerPage,
      TextFilter,
      ChecklistTypeID,
    },
    token: `Bearer ${state.sensitive.apiToken}`,
  }))(getCheckListAction)
}

// get detail
export const getCheckListById = (CheckListID: number) => {
  return withAPIAction(state => ({
    method: 'POST',
    path: 'GetConstructPlanCheckListById',
    data: { CheckListID, UserEmail: state.sensitive.userEmail },
    token: `Bearer ${state.sensitive.apiToken}`,
  }))(getCheckListByIdAction)
}

// create check list
export const createCheckList = (data: CreateCheckListReq) => {
  return withAPIAction(state => ({
    method: 'POST',
    path: 'CreateConstructPlanCheckList',
    data,
    token: `Bearer ${state.sensitive.apiToken}`,
  }))(createCheckListAction)
}

// update check list
export const updateCheckList = (data: UpdateCheckListReq) => {
  return withAPIAction(state => ({
    method: 'POST',
    path: 'UpdateConstructPlanCheckList',
    data,
    token: `Bearer ${state.sensitive.apiToken}`,
  }))(updateCheckListAction)
}

// delete check list
export const deleteCheckList = (CheckListID: number) => {
  return withAPIAction(state => ({
    method: 'POST',
    path: 'DeleteConstructPlanCheckList',
    data: { CheckListID, UserEmail: state.sensitive.userEmail },
    token: `Bearer ${state.sensitive.apiToken}`,
  }))(deleteCheckListAction)
}

export const getProjectSelector = (CheckListTypeID: number) => {
  return withAPIAction(state => ({
    method: 'POST',
    path: 'GetProjectOnConstructPlanCheckList',
    data: {
      UserEmail: state.sensitive.userEmail,
      CheckListTypeID: CheckListTypeID,
    },
    token: `Bearer ${state.sensitive.apiToken}`,
  }))(getProjectAction)
}
